import React from 'react';
import { cn } from '@/lib/utils';

export interface LogoLoaderProps {
  size?: 'sm' | 'md' | 'lg' | 'xl';
  className?: string;
  text?: string;
  showText?: boolean;
}

const sizeMap = {
  sm: 'w-6 h-6',
  md: 'w-12 h-12',
  lg: 'w-20 h-20',
  xl: 'w-32 h-32',
};

export function LogoLoader({ 
  size = 'md', 
  className,
  text,
  showText = false 
}: LogoLoaderProps) {
  const sizeClass = sizeMap[size];
  
  return (
    <div className={cn('flex flex-col items-center justify-center', className)}>
      <div className={cn('relative', sizeClass)}>
        <div className="logo-morph absolute inset-0">
          <img 
            src="/images/logos/logo_outline.png" 
            alt="" 
            className="logo-outline absolute inset-0 w-full h-full object-contain"
            aria-hidden="true"
          />
          <img 
            src="/images/logos/logo_color.png" 
            alt="" 
            className="logo-filled absolute inset-0 w-full h-full object-contain"
            aria-hidden="true"
          />
        </div>
      </div>
      {(showText || text) && (
        <p className="mt-4 text-sm text-slate-600">
          {text || 'Loading...'}
        </p>
      )}
    </div>
  );
}

